// import React, { useState, useEffect, Fragment } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import "./icon.css";
// import { BrowserRouter, Route, Switch, Redirect, Routes, Navigate, ScrollRestoration } from "react-router-dom";
// // import { ScrollContext } from "react-router-scroll-4";
// import * as serviceWorker from "./serviceWorker";
// import { Provider } from "react-redux";
// // import indexStore from "./store/index";

// // ** Import custom components for redux**
// // import { Provider } from "react-redux";
// // import store from "./store/index";
// import App from "./components/app";
// // import Home from "./pages/home";
// import Routs from "./routes";
// import "./index.css";
// // import "./assets/css/bootstrap.css";
// // import "./assets/css/easy-responsive-tabs.css";
// // import "./assets/css/flexslider.css";
// // import "./assets/css/font-awesome.css";
// // import "./assets/css/jquery-ui.css";
// // import "./assets/css/style.css";
// // import "./assets/css/team.css";

// //firebase Auth
// function Root() {
//   const user = true;
//   console.log({ env: process.env });
//   return (
//     <div className="App">
//       {/* <Provider> */}
//       {/* <BrowserRouter basename={`/`}>
//         <ScrollContext>
//           <Switch>
//             <Fragment>
//               <App>
//                 <Route
//                   exact
//                   path={`/home`}
//                   render={() => {
//                     return <Redirect to={`/`} />;
//                   }}
//                 />
//                 <Route path={`/`} component={Routs} />
//               </App>
//             </Fragment>
//           </Switch>
//         </ScrollContext>
//       </BrowserRouter> */}
//       <BrowserRouter basename={`/`}>
//         <ScrollRestoration>
//           <Routes>
//             <Fragment>
//               <App>
//                 <Route
//                   exact
//                   path={`/home`}
//                   render={() => {
//                     return <Navigate to={`/`} />;
//                   }}
//                 />
//                 <Route path={`/`} component={Routs} />
//               </App>
//             </Fragment>
//           </Routes>
//         </ScrollRestoration>
//       </BrowserRouter>
//     </div>
//   );
// }

// // ReactDOM.render(<Root />, document.getElementById("root"));
// ReactDOM.createRoot(<Root />, document.getElementById("root"));

// serviceWorker.unregister();


// function Root() {
//   return (
//     <div className="App">
//       <BrowserRouter basename="/">
//         <Routes>
//           <Route
//             path="/home"
//             element={<Navigate to="/" replace />}
//           />
//           <Route
//             path="/"
//             element={
//               <App>
//                 <Routs />
//               </App>
//             }
//           />
//         </Routes>
//       </BrowserRouter>
//     </div>
//   );
// }

import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import AppLayout from "./components/app";
import Home from "./routes/home/index";
import ProductView from "./routes/productView/index";
import SearchView from "./routes/searchView/index";
import CategoryView from "./routes/categoryView/index";
import BrandView from "./routes//brandView/index";
import ContactUs from "./routes/contactUs/index";
import AboutUs from "./routes/aboutUs/index";
import ThanksView from "./routes/thanksView/index";
import "./index.css";
import "./icon.css";

function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/thanks" element={<ThanksView />} />

          <Route
            path="/product/:brandId/:categoryId/:productId"
            element={<ProductView />}
          />

          <Route path="/products" element={<Home />} />
          <Route path="/brand" element={<Home />} />

          <Route
            path="/products/:categoryUrl"
            element={<CategoryView />}
          />

          <Route path="/brand/:brandUrl" element={<BrandView />} />
          <Route path="/search/:searchValue" element={<SearchView />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}


const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(<Root />);

serviceWorker.unregister();
